module.exports = __webpack_public_path__ + "static/media/system_flow_evaluation.8ab065ae.svg";